import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectAction} from '../message/ConnectAction';

export class ConnectActionWrapper extends BaseWrapper<ConnectAction, BasicCriteria, BasicScenario>  {}

